import React, { useEffect, useState } from 'react';
import MessageAnalytics from './child/MessageAnalytics';
import HourlyMessageAnalytics from './child/HourlyMessageAnalytics';
import CampaignAnaLytics from './child/CampaignAnaLytics';
import RecentActivityAnalytics from './child/RecentActivityAnalytics';
import TopPerformerOne from './child/TopPerformerOne';
import TopCountries from './child/TopCountries';
import GeneratedContent from './child/GeneratedContent';
import AnalyticCard from './child/AnalyticCard';
import { apiCall } from '../utils/apiService';

const DashboardLayer = () => {
  const [data, setData] = useState({});
  const fetchDashboard = async () => {
    try {
      const data = await apiCall({
        url: `user/get-dashboard`,
        method: 'GET',
      });
      setData(data);
    } catch (error) {
      console.error('Error fetching dashboard:', error);
    }
  };
  useEffect(() => {
    document.title = "User Dashoard"
    fetchDashboard();
  }, [])
  return (
    <>
      {/* AnalyticCard */}
      <AnalyticCard data={data} />

      <section className="row gy-4 mt-1">

        {/* MessageAnalytics */}
        <MessageAnalytics dataMap={data.messageAnalytics} />

        {/* CampaignAnaLytics */}
        <CampaignAnaLytics dataMap={data.campaignAnalytics} />

        {/* RecentActivityAnalytics */}
        <RecentActivityAnalytics />

         {/* HourlyMessageAnalytics */}
        <HourlyMessageAnalytics dataMap={data.hourlyAnalytics} />

      </section>
    </>


  )
}

export default DashboardLayer